export const LOAD_CONTENT = 'hg/accountMultipleAddress/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'hg/accountMultipleAddress/DL_PAGE_LOADED';
export const SET_DATA = 'hg/accountMultipleAddress/SET_DATA';
export const SET_ADDRESS = 'hg/accountMultipleAddress/SET_ADDRESS';

const initialState = {
  customerBillingAccounts: []
};

export const accountMultipleAddress = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_DATA:
      return {
        ...state,
        customerBillingAccounts: action.payload.customerBillingAccounts
      };

    default:
      return state;
  }
};

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};

export const setAddress = accountNumber => {
  return {
    type: SET_ADDRESS,
    accountNumber
  };
};

export default accountMultipleAddress;



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Account/multipleAddress/multipleAddress.js
 **/